module.exports = __webpack_public_path__ + "static/media/basil-chicken.82270d65.jpg";